import { render, staticRenderFns } from "./TableMaterial.vue?vue&type=template&id=01632564&scoped=true&"
import script from "./TableMaterial.vue?vue&type=script&lang=js&"
export * from "./TableMaterial.vue?vue&type=script&lang=js&"
import style0 from "./TableMaterial.vue?vue&type=style&index=0&id=01632564&scoped=true&lang=css&"
import style1 from "./TableMaterial.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01632564",
  null
  
)

export default component.exports